import { createSlice } from "@reduxjs/toolkit";
import addDoctorDiscountApi from "@custom/rtk-apis/billing/doctorDiscount/addDoctorDiscount";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const addDoctorDiscountSlice = createSlice({
  name: "addDoctorDiscountSlice",
  initialState,
  reducers: {
    clearAddDoctorDiscount: (state) => {
        state.status = "";
        state.result = null;
        state.msg = "";
        state.loading = false;
        state.error = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addDoctorDiscountApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addDoctorDiscountApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(addDoctorDiscountApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default addDoctorDiscountSlice.reducer;
export const { clearAddDoctorDiscount } = addDoctorDiscountSlice.actions;
